import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import { preset } from 'vue-cli-plugin-vuetify-preset-fortnightly/preset'

Vue.use(Vuetify);

preset.theme = {
  themes: {
    light: {
      secondary: '#424242',
      accent: '#82B1FF',
      error: '#FF5252',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FB8C00',
    },
  },
}

export default new Vuetify({
  preset,
  icons: {
    iconfont: 'mdi'
  },
});
